import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const readUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
};

// Same grant the sidebar uses: ADMIN, or '/forms' listed in the user's accessibleReports.
// Reads localStorage synchronously (useAuth hydrates in an effect, which would flash a redirect).
export default function FormsGuard({ children }) {
  const { pathname } = useLocation();
  const user = readUser();
  const allowed = user?.roleType === 'ADMIN' || !!user?.accessibleReports?.includes('/forms');
  if (!allowed) return <Navigate to={pathname.startsWith('/crm-view') ? '/crm-view' : '/'} replace />;
  return children;
}
